import i18n from '@/utils/i18n';
import React, { useCallback } from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { Button } from '@/components/button';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { OrderGuidePartitionList } from '@/components/order-guide-partition-list';
import { Text, useWindowDimensions, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  onClose: () => void;
  onPartitionSelect: (partitionUUID: string) => void;
  variantPackUUID: string;
}

const SHEET_HORIZONTAL_PADDING = 16;

export const SearchNotePartitionSheet: React.FC<Props> = ({
  onClose,
  onPartitionSelect,
  variantPackUUID,
}) => {
  const { height } = useWindowDimensions();

  const { isSmallLayout } = useLayoutContext();
  const [styles] = useStyles();

  const handlePartitionSelect = useCallback(
    (partitionUUID: string) => {
      onClose();
      onPartitionSelect(partitionUUID);
    },
    [onClose, onPartitionSelect],
  );

  return (
    <BaseActionSheet
      contentStyle={[
        styles.content,
        isSmallLayout ? styles.contentSmall : null,
        {
          maxHeight: height * 0.85,
        },
      ]}
      isVisible
      modalCloseButtonProps={{
        children: i18n.t('done'),
      }}
      onClose={onClose}
      title={i18n.t('add_item_note')}
    >
      {isSmallLayout ? (
        <View style={styles.smallLayoutHeader}>
          <View style={styles.smallLayoutHeaderSide} />
          <View style={styles.smallLayoutHeaderCenter}>
            <Text
              numberOfLines={1}
              style={[TYPOGRAPHY.large, FONTS.primaryBold]}
            >
              {i18n.t('add_item_note')}
            </Text>
          </View>
          <View style={styles.smallLayoutHeaderSide}>
            <Button
              onPress={onClose}
              size="xsmall"
              style={styles.smallLayoutDoneButton}
              textStyle={[TYPOGRAPHY.large, FONTS.primaryBold]}
              trackingData={{
                name: 'order_guide_partition_selector.done_button',
              }}
              type="tertiary"
            >
              {i18n.t('done')}
            </Button>
          </View>
        </View>
      ) : null}
      <OrderGuidePartitionList
        mode="select"
        onSelectPartitionOverride={handlePartitionSelect}
        variantPackUUID={variantPackUUID}
      />
    </BaseActionSheet>
  );
};

const useStyles = createStyles((theme) => ({
  content: {
    paddingBottom: 0,
    paddingHorizontal: 0,
  },
  contentSmall: {
    paddingTop: SCREEN_PADDING,
  },
  smallLayoutDoneButton: {
    paddingHorizontal: 0,
  },
  smallLayoutHeader: {
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: theme.sk.spacing.spaceSmall,
    paddingHorizontal: SHEET_HORIZONTAL_PADDING,
  },
  smallLayoutHeaderCenter: {
    alignItems: 'center',
    flex: 5,
  },
  smallLayoutHeaderSide: {
    alignItems: 'flex-end',
    flex: 1,
  },
}));
